// import { useNavigation } from '@react-navigation/native';
import { XIcon } from 'react-native-heroicons/solid';
import { IconButton } from 'native-base';
import { theme } from '@breakroom-nx/assets';

export const AuthCloseButton = () => {
  // const navigation = useNavigation();

  return (
    <IconButton
      onPress={() => {
        // navigation.goBack();
      }}
      bg={'rgba(255, 255, 255, 0.07)'}
      borderRadius={'full'}
      position={'absolute'}
      zIndex={9999}
      mt={9}
      p={'11px'}
      right={'0px'}
      icon={<XIcon color={theme.colors.primary[400]} size={20} />}
      _pressed={{
        backgroundColor: 'rgba(255, 255, 255, 0.07)',
        opacity: 0.7,
      }}
    />
  );
};
